<template>
  <v-container
    id="how"
    class="pa-0"
    fluid
    tag="section"
  >
    <v-row
      class="ma-0"
      no-gutters
    >
      <v-col
        cols="12"
        md="6"
      >
        <v-img
          height="calc(100vh - 96px - 156px)"
          gradient="to top, rgba(0, 0, 0, .7), rgba(0, 0, 0, .6)"
          :src="require('@/assets/foods.webp')"
        />
      </v-col>

      <v-col
        class="d-block d-md-flex align-center grey lighten-3 pa-6"
        cols="12"
        md="6"
      >
        <v-responsive
          class="mx-auto px-3 px-md-12"
          max-width="750"
        >
          <h1
            class="mb-6"
            :class="$vuetify.breakpoint.mdAndUp ? 'display-2' : 'display-1'"
          >
            How?
          </h1>

          <p>
            <b>Food and drinks will be provided</b>, we will run an open bar.
            It is ok to bring your own drinks.
            The establishment does not have a serving permit.
          </p>
          <p>
            <b>There will be a buffet in mediterranian style.</b>
            Please inform us in the provided form if you are allergic to any foods
            or vegetarian. (Vegan report as allergy).
          </p>
          <p>
            <b>Please fill out the form</b> with information about yourself, how you
            know the bride or groom, some anecdote or similar. This information will
            be of use to the toastmaster!
            If you would like to hold a speech, do some standup or gyckel, please let us know.
            There might also be room for more for late deciders.
          </p>
          <p>
            <b>Regarding gifts</b>, we are happy to recieve whatever you would like to bring,
            but consider these charities:
            <ul>
              <li>
                <a
                  href="https://centrumforrattvisa.se/ge-en-gava/"
                  target="_blank"
                >Centrum för rättvisa</a>
              </li>
              <li>
                <a
                  href="https://lakareutangranser.se/stod-oss"
                  target="_blank"
                >Läkare utan gränser</a>
              </li>
              <li>
                <a
                  href="https://www.alzheimerfonden.se/ge-en-gava/"
                  target="_blank"
                >Alzeimerfonden</a>
              </li>
              <li>
                <a
                  href="https://nordensark.se/stod-oss/"
                  target="_blank"
                >
                  Nordens Ark</a>
              </li>
              <li>Or donate to a charity of choice</li>
            </ul>
          </p>
        </v-responsive>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'How',
  }
</script>

<style lang="sass">
  .signature
    font-family: 'Cedarville Cursive', cursive !important
    font-size: 2rem
    font-style: italic
</style>
